import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { useConfig } from '#/hooks/useConfig';
import { useResponsiveFormFactor } from '#/hooks/useResponsiveValue';
import { useUnauthenticatedHomePage } from '#/pages/UnauthenticatedHomePage/UnauthenticatedHomePage.hook';
import { StorageKeys } from '#/service/constants';
import { Path } from '#/service/routes';

export const useTermsModal = (isAppReady: boolean) => {
  const {
    shouldShow: showUnauthenticatedHomePage,
    isLoading: isUnauthenticatedHomePageLoading,
  } = useUnauthenticatedHomePage();

  const { terms } = useConfig();
  const [showTerms, setShowTerms] = useState(false);
  const { pathname } = useLocation();

  const isUnauthenticatedHomePage =
    showUnauthenticatedHomePage && Path.Home === pathname;
  const isRegistrationPage = pathname.includes(Path.Registration);

  const shouldShowTerms = useCallback(() => {
    const currentTermsVersion = localStorage.getItem(StorageKeys.TERMS);

    return !!(
      !isUnauthenticatedHomePageLoading &&
      !isUnauthenticatedHomePage &&
      !isRegistrationPage &&
      isAppReady &&
      terms.body &&
      currentTermsVersion !== terms.date
    );
  }, [
    isAppReady,
    isUnauthenticatedHomePageLoading,
    isRegistrationPage,
    isUnauthenticatedHomePage,
    terms.body,
    terms.date,
  ]);

  const acceptTerms = useCallback(() => {
    setShowTerms(false);
    localStorage.setItem(StorageKeys.TERMS, terms.date);
  }, [terms.date]);

  useEffect(() => {
    setShowTerms(shouldShowTerms());
  }, [shouldShowTerms]);

  return {
    formFactor: useResponsiveFormFactor(),
    showTerms,
    terms,
    acceptTerms,
    shouldShowTerms,
  };
};
